/**
 * @desc 从后台获取保险信息相关接口
 * */

import { request } from '../util/request'

/**
 * @name GetInsurancePlanListForApp
 * @desc 获取保险产品列表
 * @param {object} params
 * @param {string} params.appCodeId
 * @param {string} params.token
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetInsurancePlanListForApp(params = {}, loadingConfig) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/insurancePlanResource/getInsurancePlanListForApp`,
    method: 'GET',
    params,
    loadingConfig
  })
}

/**
 * @name GetInsurancePlanDetail
 * @desc 获取保险产品详情及附属文件
 * @param {object} params
 * @param {string} params.insurancePlanId
 * @param {string} params.token
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetInsurancePlanDetail(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/insurancePlanResource/getInsurancePlanDetail`,
    method: 'GET',
    params,
    loadingConfig
  })
}

/**
 * @name GetCompanyList
 * @desc 获取保险公司列表
 * @param {object} params
 * @param {string} params.token
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function GetCompanyList(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/bizzUserResource/getCompanyList`,
    method: 'GET',
    params,
    loadingConfig
  })
}

/**
 * @name CheckForwarding
 * @desc 分享到朋友圈之后领取奖励
 * @param {object} params
 * @param {string} params.token
 * @param {string} params.openId
 * @param {object} loadingConfig
 * @param {boolean} loadingConfig.isShow
 * @param {string} loadingConfig.text
 * */
export function CheckForwarding(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/forwardingResource/checkForwarding`,
    method: 'POST',
    data: params,
    loadingConfig
  })
}

// 保费试算

export function premiumTrial(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/userInsuranceResource/calculationUserInsure`,
    method: 'POST',
    data: params,
    loadingConfig
  })
}


export function checkMobileVerify(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/checkMobileVerify`,
    method: 'POST',
    data: params,
    loadingConfig
  })
}
// 全国投保省市区查询
// services/front/areaResource/getProvinces 省
// services/front/areaResource/getCities?code=370000 市
// services/front/areaResource/getDistricts?code=371300  区
export function getProvinces(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/areaResource/getProvinces`,
    method: 'GET',
    params,
    loadingConfig
  })
}
export function getCities(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/areaResource/getCities`,
    method: 'GET',
    params,
    loadingConfig
  })
}
export function getDistricts(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/areaResource/getDistricts`,
    method: 'GET',
    params,
    loadingConfig
  })
}
// 根据路径参数回显投保人信息
export function getInfomation(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/des/decrypt`,
    method: 'POST',
    data: params,
    loadingConfig
  })
}
// 根据路径参数判断是否可以进行投保操作
export function judgeChannel(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/getAgentUser`,
    method: 'POST',
    data: params,
    loadingConfig
  })
}

// 退出登录
export function loginOut(params = {}, loadingConfig = {}) {
  return request({
    url: `${process.env.VUE_APP_API_PATH}/services/front/wechatUser/loginOut`,
    method: 'POST',
    data: params,
    loadingConfig
  })
}